import React, { useEffect, useRef } from 'react';

interface ScrollFadeComponentProps {
    children: React.ReactNode;
    variant?: 'fadeX' | 'fadeY';
}

const ScrollFadeComponent: React.FC<ScrollFadeComponentProps> = ({ children, variant }) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const container = containerRef.current;

        if (!container) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        container.classList.add('visible');
                    } else {
                        container.classList.remove('visible');
                    }
                });
            },
            {
                threshold: 0.5, // Progi obserwacji - dostosuj wartość do swoich potrzeb
            }
        );

        observer.observe(container);

        return () => {
            observer.unobserve(container);
        };
    }, []);

    const baseClass =
        variant === 'fadeX'
            ? 'scroll-fade-component-fadeX'
            : 'scroll-fade-component-fadeY';

    return (
        <div ref={containerRef} className={baseClass}>
            {children}
        </div>
    );
};

export default ScrollFadeComponent;
